<div class="connect-lead-modal-overlay"
    *ngIf="isConnectLeadPopupOpen"
    (click)="closeConnectLeadPopup()">
    <div class="connect-lead-modal"
        (click)="$event.stopPropagation()">
        <div class="connect-lead-header">
            <div>
                <ng-container *ngIf="isPublicDemo; else liveConnectCopy">
                    <h3>Interested to know more?</h3>
                    <p>Share the details below and our team will connect with you within 2 hours.</p>
                </ng-container>
                <ng-template #liveConnectCopy>
                    <h3>Connect with Suppliers</h3>
                    <p>Share your details and we will help you get started.</p>
                </ng-template>
            </div>
            <button type="button"
                class="connect-lead-close"
                (click)="closeConnectLeadPopup()"
                aria-label="Close">
                <i class="material-icons">close</i>
            </button>
        </div>

        <form class="connect-lead-form"
            (ngSubmit)="submitConnectLeadForm()">
            <div class="connect-lead-field">
                <label for="connectLeadFullName">Full Name</label>
                <input id="connectLeadFullName"
                    type="text"
                    [(ngModel)]="connectLeadForm.full_name"
                    name="full_name"
                    placeholder="Enter full name"
                    autocomplete="name">
                <span class="connect-lead-error"
                    *ngIf="connectLeadErrors.full_name">{{ connectLeadErrors.full_name }}</span>
            </div>

            <div class="connect-lead-field">
                <label for="connectLeadPhone">Phone Number</label>
                <input id="connectLeadPhone"
                    type="tel"
                    [(ngModel)]="connectLeadForm.phone_number"
                    name="phone_number"
                    placeholder="+91 9876543210"
                    autocomplete="tel">
                <span class="connect-lead-error"
                    *ngIf="connectLeadErrors.phone_number">{{ connectLeadErrors.phone_number }}</span>
            </div>

            <div class="connect-lead-field">
                <label for="connectLeadEmail">Email</label>
                <input id="connectLeadEmail"
                    type="email"
                    [(ngModel)]="connectLeadForm.email"
                    name="email"
                    placeholder="user@example.com"
                    autocomplete="email">
                <span class="connect-lead-error"
                    *ngIf="connectLeadErrors.email">{{ connectLeadErrors.email }}</span>
            </div>

            <div class="connect-lead-field connect-lead-city-field">
                <label for="connectLeadCity">City</label>
                <input id="connectLeadCity"
                    type="text"
                    [ngModel]="connectLeadCityQuery"
                    (ngModelChange)="onConnectLeadCityQueryChange($event)"
                    name="city_query"
                    placeholder="Search and select city"
                    autocomplete="off"
                    (focus)="showConnectLeadCityDropdown = true">
                <div class="connect-lead-city-dropdown"
                    *ngIf="showConnectLeadCityDropdown">
                    <div class="connect-lead-city-loading"
                        *ngIf="isConnectLeadCitiesLoading">Loading cities...</div>
                    <button type="button"
                        class="connect-lead-city-option"
                        *ngFor="let option of filteredConnectLeadCities"
                        (click)="selectConnectLeadCity(option)">
                        {{ option.label }}
                    </button>
                    <div class="connect-lead-city-empty"
                        *ngIf="!isConnectLeadCitiesLoading && filteredConnectLeadCities.length === 0">
                        No cities found
                    </div>
                </div>
                <span class="connect-lead-error"
                    *ngIf="connectLeadErrors.city">{{ connectLeadErrors.city }}</span>
            </div>

            <div class="connect-lead-field">
                <label for="connectLeadBusiness">Business Name</label>
                <input id="connectLeadBusiness"
                    type="text"
                    [(ngModel)]="connectLeadForm.business_name"
                    name="business_name"
                    placeholder="Enter business name"
                    autocomplete="organization">
                <span class="connect-lead-error"
                    *ngIf="connectLeadErrors.business_name">{{ connectLeadErrors.business_name }}</span>
            </div>

            <div class="connect-lead-actions">
                <button type="button"
                    class="connect-lead-cancel"
                    (click)="closeConnectLeadPopup()"
                    [disabled]="isConnectLeadSubmitting">
                    Cancel
                </button>
                <button type="submit"
                    class="connect-lead-submit"
                    [disabled]="isConnectLeadSubmitting">
                    {{ isConnectLeadSubmitting ? 'Submitting...' : 'Submit' }}
                </button>
            </div>
        </form>
    </div>
</div>
